import React, { useState, useEffect } from "react";
import CustomFilters from "../../../../core/custom-filters";
import { HTTP_METHODS, plainApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import SiAutocomplete from "../../../../core/si-autocomplete";
import SiTextField from "../../../../core/si-textfield";

const MONTH_OPTIONS = [
    { label: "January", value: "0" },
    { label: "February", value: "1" },
    { label: "March", value: "2" },
    { label: "April", value: "3" },
    { label: "May", value: "4" },
    { label: "June", value: "5" },
    { label: "July", value: "6" },
    { label: "August", value: "7" },
    { label: "September", value: "8" },
    { label: "October", value: "9" },
    { label: "November", value: "10" },
    { label: "December", value: "11" },
];

const generateFYOptions = () => {
    const currentYear = new Date().getFullYear();
    const options = [];
    for (let y = currentYear - 4; y <= currentYear + 1; y++) {
        const label = `${y}-${String(y + 1).slice(-2)}`;
        options.push({ label, value: label });
    }
    return options.reverse();
};

const FY_OPTIONS = generateFYOptions();

const FILTER_TYPES = [
    { label: "Filter by OEM", value: "oem" },
    { label: "Filter by Training Content", value: "courseName" },
    { label: "Filter by Month", value: "month" },
    { label: "Filter by Financial Year", value: "fy" },
];

const TrainingApprovalFilters = ({ loadData }) => {
    const [filterType, setFilterType] = useState("");
    const [filterValue, setFilterValue] = useState("");
    const [oemList, setOemList] = useState([]);

    let oemTimeout = null;

    /* ─── apply / clear ─── */
    const applyFilters = (filters) => {
        if (Object.keys(filters).length) {
            const payload = {};
            for (let key in filters) {
                const val = filters[key];
                payload[key] = typeof val === "object" && val?.value ? val.value : val;
            }
            loadData(payload);
        } else {
            loadData({});
        }
    };

    /* ─── input renderers ─── */
    const renderFilterInput = () => {
        switch (filterType) {
            case "oem":
                return (
                    <SiAutocomplete
                        onChange={setFilterValue}
                        options={oemList}
                        placeholder="Search OEM"
                        onInputChange={(newValue) => handleOemSearch(newValue)}
                    />
                );

            case "courseName":
                return (
                    <SiTextField
                        placeholder="Training Content"
                        name="courseName"
                        onChange={(e) => setFilterValue(e.target.value)}
                    />
                );

            case "month":
                return (
                    <SiAutocomplete
                        onChange={setFilterValue}
                        options={MONTH_OPTIONS}
                        placeholder="Select Month"
                    />
                );

            case "fy":
                return (
                    <SiAutocomplete
                        onChange={setFilterValue}
                        options={FY_OPTIONS}
                        placeholder="Select Financial Year"
                    />
                );

            default:
                return null;
        }
    };

    /* ─── OEM search ─── */
    const fetchOemList = (inputValue) => {
        const params = inputValue ? { name: inputValue } : {};
        plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.LIST_ADMIN_OEMS}`, null, params)
            .then((response) => {
                if (Array.isArray(response)) {
                    setOemList(
                        response.map((r) => ({ ...r, label: `${r.code}-${r.name}`, value: r.id }))
                    );
                }
            })
            .catch((err) => console.error(err));
    };

    const handleOemSearch = (newValue) => {
        clearTimeout(oemTimeout);
        if (newValue) {
            oemTimeout = setTimeout(() => fetchOemList(newValue), 300);
        }
    };

    /* ─── Prefetch lists when filter type changes ─── */
    useEffect(() => {
        if (filterType === "oem") fetchOemList();
    }, [filterType]);

    return (
        <div>
            <CustomFilters
                applyFilters={applyFilters}
                renderFilterInput={renderFilterInput}
                filterTypes={FILTER_TYPES}
                filterType={filterType}
                setFilterType={setFilterType}
                filterValue={filterValue}
                setFilterValue={setFilterValue}
            />
        </div>
    );
};

export default TrainingApprovalFilters;
